import Reactions from './Reactions.container';

export default Reactions;
